export const prettyPhone = (phone: string): string => {
  if (phone.length <= 12) throw new Error('Invalid phone number');

  return [
    phone.substring(0, 3),
    phone.substring(3, 6),
    phone.substring(6, 9),
    phone.substring(9, 12),
    phone.substring(12),
  ].join(' ');
};
